module.exports = __webpack_public_path__ + "media/sustainable_sales/bg-57bdffbe.png";